
<div class="rpa-duration" @click.stop>
  <div v-if="runtime" :class="['rpa-duration__runtime', { 'rpa-duration__runtime--compact': compact }]" role="status" aria-live="polite">
    <template v-if="compact">
      <span>{{ view.short }}</span>
    </template>
    <template v-else>
      <div class="rpa-duration__heading"><span>{{ view.title }}</span></div>
      <strong class="rpa-duration__value">{{ view.value }}</strong>
      <div v-if="view.range" class="rpa-duration__range">{{ view.range }}</div>
      <div v-if="view.detail" class="rpa-duration__detail">{{ view.detail }}</div>
      <div class="rpa-duration__note">{{ view.note }}</div>
    </template>
  </div>
  <v-menu v-else v-model="open" offset-y left :close-on-content-click="false" max-width="360">
    <template v-slot:activator="{ on, attrs }">
      <button type="button" class="rpa-duration__trigger" v-bind="attrs" v-on="on" :aria-label="view.short" data-testid="rpa-duration-estimate">
        <v-icon size="17" color="#687EFF">mdi-clock-outline</v-icon>
        <span>{{ view.short }}</span>
      </button>
    </template>
    <section class="rpa-duration__menu">
      <div class="rpa-duration__heading">
        <strong>예상 소요 시간</strong>
        <div class="rpa-duration__actions">
          <button type="button" :disabled="state.loading || !target.ready" aria-label="예상 시간 다시 조회" @click="refresh"><v-icon size="18">mdi-refresh</v-icon></button>
          <button type="button" aria-label="예상 시간 닫기" @click="open = false"><v-icon size="18">mdi-close</v-icon></button>
        </div>
      </div>
      <div :class="['rpa-duration__card', { 'rpa-duration__card--warning': view.warning }]" role="status" aria-live="polite">
        <div class="rpa-duration__eyebrow">{{ view.reference ? '참고용 예측' : view.title }}</div>
        <strong class="rpa-duration__value">{{ view.value }}</strong>
        <div v-if="view.range" class="rpa-duration__range">{{ view.range }}</div>
      </div>
      <p class="rpa-duration__note">{{ view.note }}</p>
    </section>
  </v-menu>
</div>
